<template>
    <div class="social-media">
        <ul class="social-links-list">
            <li v-for="(social,i) in socialMedia"
                :key="`social-link-${i}`"
                class="social-media-item">
                <a :href="social.url" target="_blank" class="social-media-link">
                    <font-awesome-icon class="icon" :icon="getSocialIcon(social.network)"/>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import faFacebookF from '@fortawesome/fontawesome-free-brands/faFacebookF'
    import faInstagram from '@fortawesome/fontawesome-free-brands/faInstagram'
    import faLinkedin from '@fortawesome/fontawesome-free-brands/faLinkedin'
    import faTwitter from '@fortawesome/fontawesome-free-brands/faTwitter'

    export default {
        name: "SocialMedia",
        data() {
            return {
                socialMedia: wp.settings.social_media,
                socialIcons: {
                    faFacebookF,
                    faLinkedin,
                    faInstagram,
                    faTwitter
                }
            }
        },
        methods: {
            getSocialIcon(network) {
                switch (network) {
                    case 'Facebook':
                        return this.socialIcons.faFacebookF;
                    case 'Twitter':
                        return this.socialIcons.faTwitter;
                    case 'LinkedIn':
                        return this.socialIcons.faLinkedin;
                    case 'Instagram':
                    default:
                        return this.socialIcons.faInstagram;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .social-links-list {
        list-style: none;
        margin: 10px 0 0;
        padding: 0;
        display: flex;
    }

    .social-media-item {
        margin-right: 20px;
        &:last-child {
            margin-right: 0;
        }
    }

    .social-media-link {
        color: $color1;
        &:hover {
            color: $color2;
        }
    }

</style>